import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { PageSection } from '../PageSection';
import { testimonials } from '../../data/salesContent';
export function TestimonialsSection() {
  return <PageSection labelledBy="testimonials-title" data-id="element-180" data-mp="1ruw81ajznlyx">
      <SectionHeading id="testimonials-title" title="Testimonios" data-id="element-181" data-mp="1rtl7rkpr4wck" />
      <ul className="mt-8 space-y-4" data-id="element-182" data-mp="1mvtb6de5wm21">
        {testimonials.map(t => <li key={t.name} className="rounded-2xl border border-zinc-800 bg-zinc-950 p-6" data-id="element-183" data-mp="1iv9grhkz3wjl">
            <figure data-id="element-184" data-mp="1dvda1akw5r0c">
              <blockquote className="text-base leading-relaxed text-zinc-100 md:text-[17px]" data-id="element-185" data-mp="1dv3l7qbl1pw8">“{t.quote}”</blockquote>
              <figcaption className="mt-5 flex items-center gap-3" data-id="element-186" data-mp="18xbrcqrdntpe">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-cyan-500 font-display text-sm font-extrabold text-zinc-950" data-id="element-187" data-mp="13yicatwfzun4">
                  {t.initials}
                </span>
                <span className="text-sm" data-id="element-188" data-mp="2yd1hx5ca6e9d">
                  <span className="block font-semibold text-white" data-id="element-189" data-mp="1t9n4w4m3vuex">{t.name}</span>
                  <span className="block text-zinc-400" data-id="element-190" data-mp="1tbq67kspl9yy">{t.location}</span>
                </span>
              </figcaption>
            </figure>
          </li>)}
      </ul>
    </PageSection>;
}